import axios from "axios"
import _EVENTBUS from "./_EVENTBUS"

const HOST = process.env.VUE_APP_API + "/hemaapi/api"

const instance = axios.create({
  baseURL: HOST
})

instance.interceptors.response.use(
  res => {
    return res
  },
  err => {
    if (err.response.status == 499) {
      _EVENTBUS.$emit("logout")
    }
  }
)

export { instance, HOST }
